import { createSlice } from '@reduxjs/toolkit'
import { injectedOmsApi } from '@/services/oms'

type Nullable<T> = T | null

type PlainInfo<T> = {
  status: RequestState
  error?: Nullable<string>
  data: Nullable<T>
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: PlainInfo<Oms.StoreItemAvailability[]> = {
  status: 'none',
  data: [],
  error: null,
}

export const storeItemAvailabilitySlice = createSlice({
  name: '@storeItemAvailability',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      injectedOmsApi.endpoints.getStoreItemAvailability.matchFulfilled,
      (state, action) => {
        state.status = 'fulfilled'
        state.data = action.payload.data.map((storeItemAvailability) => ({
          ...storeItemAvailability,
          unavailableStores: (
            storeItemAvailability.unavailableStores as unknown as {
              storeId: string
              endDateTime: number
            }[]
          ).reduce(
            (obj, item) => ({
              ...obj,
              [item.storeId]: item,
            }),
            []
          ),
        }))
      }
    )
  },
})
